// Target values mapping
export const TARGET_LABELS = {
  1: 'Dashboard',
  2: 'Content',
  3: 'Meal Plan',
  4: 'Fitness Program',
  5: 'Nutrition Program',
  6: 'Wellness Program',
  7: 'Blood Results',
  8: 'MirrorMirror',
  9: 'Widgets Dashboard',
  10: 'Fasting Screen',
  11: 'Women Cycle Screen',
  12: 'Program Details Screen',
  13: 'Content Details Screen'
};

export const TARGET_OPTIONS = Object.entries(TARGET_LABELS).map(([value, label]) => ({
  value: parseInt(value),
  label
}));

export const getTargetLabel = (target) => {
  return TARGET_LABELS[target] || target;
};
